module.exports = __webpack_public_path__ + "img/hug_ios_802.png";